export const auth = {
  login: 'Sign In',
  register: 'Sign Up',
  resetPassword: 'Reset Password',
  loginSubtitle: 'Sign in to manage your customers',
  registerSubtitle: 'Create a new account',
  resetSubtitle: 'Enter your email address to reset your password',
  email: 'Email Address',
  password: 'Password',
  displayName: 'Full Name',
  emailRequired: 'Email address is required',
  passwordRequired: 'Password is required',
  displayNameRequired: 'Full name is required',
  invalidEmail: 'Invalid email format',
  passwordTooShort: 'Password must be at least 6 characters long',
  forgotPassword: 'Forgot your password?',
  noAccount: 'Don\'t have an account? Sign up!',
  backToLogin: '← Back to sign in',
  processing: 'Processing...',
  signInWithGoogle: 'Sign in with Google',
  acceptTerms: 'By continuing you accept YouCRM\'s',
  termsOfService: 'Terms of Service',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  or: 'or'
};
